module.exports = {"230305001":"街里街道","230305002":"穆棱街道","230305003":"平岗街道","230305101":"梨树镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230305.json
// module id = 798
// module chunks = 0